import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ApplicationForm from '../../../components/TradeLicense/ApplicationForm';
import { tradeLicenseApi } from '../../../services/tradeLicenseApi';

const ApplicationCreate = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    tradeLicenseApi.getCategories()
      .then((res) => setCategories(res.data.results || res.data))
      .catch(console.error);
  }, []);

  const handleSuccess = (data) => {
    alert(`Application created successfully!\nApplication #: ${data.application_number}`);
    navigate(`/office/applications/${data.id}`);
  };

  return (
    <div>
      <h1 className="page-title">New Trade License Application</h1>
      <ApplicationForm categories={categories} onSuccess={handleSuccess} officeMode />
    </div>
  );
};

export default ApplicationCreate;
